import * as React from "react";
const SvgRewardsOutlined = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={props.fill || "currentColor"}
      d="M4 20v-9q-.824 0-1.412-.588A1.93 1.93 0 0 1 2 9V7q0-.824.587-1.412A1.93 1.93 0 0 1 4 5h3.2a1.4 1.4 0 0 1-.163-.475A3.5 3.5 0 0 1 7 4q0-1.25.875-2.125A2.9 2.9 0 0 1 10 1q.575 0 1.075.212.5.213.925.588.425-.4.925-.6T14 1q1.25 0 2.125.875T17 4q0 .274-.05.513-.05.237-.15.487H20q.824 0 1.413.588Q22 6.175 22 7v2q0 .825-.587 1.412A1.93 1.93 0 0 1 20 11v9q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22H6q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20M14 3a.97.97 0 0 0-.713.288A.97.97 0 0 0 13 4q0 .424.287.713Q13.576 5 14 5q.424 0 .713-.287A.97.97 0 0 0 15 4a.97.97 0 0 0-.287-.712A.97.97 0 0 0 14 3M9 4q0 .424.287.713Q9.576 5 10 5q.424 0 .713-.287A.97.97 0 0 0 11 4a.97.97 0 0 0-.287-.712A.97.97 0 0 0 10 3a.97.97 0 0 0-.713.288A.97.97 0 0 0 9 4M4 7v2h7V7zm7 13v-9H6v9zm2 0h5v-9h-5zm7-11V7h-7v2z"
    />
  </svg>
);
export default SvgRewardsOutlined;
